<template>
  <div class="container-scroller">
    <!-- partial:partials/_navbar.html -->
    <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div class="navbar-brand-wrapper d-flex align-items-center justify-content-between">
        <a href="/" class='navbar-brand brand-logo'>
          <img src="/static/images/logo.png" alt="logo"/> 
          <span style='color: #9c9fa6;'>TradingApp</span>
        </a>
        <a href="/" class='navbar-brand brand-logo-mini'>
          <img src="/static/images/logo.png" alt="logo"/>
        </a>
      </div>
      <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end" style="position: relative">
        <!-- <div class="coin-widget" style="background-color: #1D2330; overflow:hidden; box-sizing: border-box; border-radius: 4px; text-align: right; line-height:14px; font-size: 12px; font-feature-settings: normal; text-size-adjust: 100%; padding:1px; padding: 0px; margin-left: 1rem; width: 100%;"><div style="height:40px; padding:0px; margin:0px; width: 100%;"><iframe src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=dark&pref_coin_id=1505&invert_hover=no" width="100%" height="36px" scrolling="auto" marginwidth="0" marginheight="0" frameborder="0" border="0" style="border:0;margin:0;padding:0;"></iframe></div></div> -->
        <ul class="navbar-nav navbar-nav-right" v-if="user_id">
          <li class="nav-item">
            <router-link to="/dashboard/new_chart" class='nav-link'>
              <i class='fas fa-chart-line fa-fw'></i><span class="menu-title d-none d-sm-inline">&nbsp;&nbsp;{{lang=="ru"?"График":"Chart"}}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/dashboard/overview" class='nav-link'>
              <i class='fas fa-tachometer-alt fa-fw'></i><span class="menu-title d-none d-sm-inline">&nbsp;&nbsp;{{lang=="ru"?"Обзор":"Overview"}}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/dashboard/market" class='nav-link'>
              <i class='fas fa-shopping-bag fa-fw'></i><span class="menu-title d-none d-sm-inline">&nbsp;&nbsp;{{lang=="ru"?"Боты":"Bots Market"}}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/dashboard/plans" class='nav-link'>
              <i class='fas fa-battery-half fa-fw'></i><span class="menu-title d-none d-sm-inline">&nbsp;&nbsp;{{plan_status==1?'Interim':(plan_status==2?'Basic':(plan_status==3?'Advanced':(plan_status==4?'Pro':'Pricing')))}}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/dashboard/settings" class='nav-link'>
              <i class='fas fa-cogs fa-fw'></i><span class="menu-title d-none d-sm-inline">&nbsp;&nbsp;{{lang=="ru"?"Настройки аккаунта":"Account settings"}}</span>
            </router-link>
          </li>
          <li class="nav-item dropdown" style="position: relative">
            <a class="nav-link dropdown-toggle" v-on:click="is_lang=!is_lang" id="navbarDarkDropdownMenuLink" role="button" data-coreui-toggle="dropdown" aria-expanded="false">
              <i class='fas fa-globe fa-fw'></i> <span class="menu-title d-none d-sm-inline">{{lang=="ru"?"RU":"EN"}}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-dark" id="b" v-if="is_lang" :style="is_lang ? 'display: block !important; min-width: 70px' : ''">
              <li v-on:click="changeLang('en')"><a class="dropdown-item">EN</a></li>
              <li v-on:click="changeLang('ru')"><a class="dropdown-item">RU</a></li>
            </ul>
          </li>
          <li class="nav-item" style="cursor: pointer;">
            <a v-on:click="logout" class="nav-link">
              <i class='fas fa-sign-out-alt fa-fw'></i><span class="menu-title d-none d-sm-inline">&nbsp;&nbsp;{{lang=="ru"?"Выйти":"Logout"}}</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
    <!-- partial -->
    <div class="container-fluid page-body-wrapper">
      <!-- partial:partials/_sidebar.html -->
      <div class="main-panel">
        <router-view></router-view>
        <footer class="footer">
          <div class="d-sm-flex justify-content-center justify-content-sm-between">
            <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023 <a href="https://tradingapp.pro/" target="_blank">Trading App</a>. {{lang=="ru"?"Все права защищены.":"All rights reserved."}}</span>
            <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted &amp; made with <i class="fa fa-heart"></i></span>
          </div>
        </footer>
        <!-- partial -->
      </div>
      <!-- main-panel ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
</template>

<script type="text/javascript">
export default {
  data () {
    return {
      user_id: 0,
      balance: 0,
      login_type: 'site',
      total_profit: 0,
      telegram_name: null,
      subscriptions: [],
      subscriptions_1: [],
      alert_email: '',
      binance_keys: false,
      lang: 'en',
      binance_refill_bnb: false,
      plan_status: 0,
      selected_tab: 3,
      plan_type: 1,
      FTX_keys: false,
      OKX_keys: false,
      Kucoin_keys: false,
      Kucoin_future_keys: false,
      is_lang: false,
      first_login: false
    }
  },
  created () {
    this.refresh_user_info()
    this.lang = this.$cookie.get('lang')
  },
  methods: {
    logout () {
      this.axios.get('/logout', {withCredentials: true})
      document.cookie = 'token=;path=/;domain=tradingapp.pro;'
      window.location.href = '/'
    },

    mouseOverLang () {
      this.is_lang = true
    },

    changeLang (lang) {
      this.axios.post('/user/update_lang', {
          lang: lang
      }, {
          withCredentials: true
      }).then(response => {
          console.log("=====lang result=====");
          console.log(response)
          document.cookie = 'lang=' + lang + ';path=/;domain=tradingapp.pro;'
          window.location.reload();
      })
    },
    
    refresh_user_info () {
      this.axios.get('/user/overview', {withCredentials: true})
        .then((userInfo) => {
          userInfo = userInfo.data
          this.user_id = userInfo.id
          this.balance = userInfo.balance
          this.plan_type = userInfo.plan_type
          this.total_profit = userInfo.total_profit
          this.telegram_name = userInfo.telegram_chat_id
          this.alert_email = userInfo.alert_email
          this.binance_keys = userInfo.binance_keys
          this.FTX_keys = userInfo.FTX_keys
          this.OKX_keys = userInfo.OKX_keys
          this.Kucoin_keys = userInfo.Kucoin_keys
          this.Kucoin_future_keys = userInfo.Kucoin_future_keys
          this.binance_refill_bnb = userInfo.binance_refill_bnb
          this.plan_status = userInfo.plan_status
          this.login_type = userInfo.login_type
          this.first_login = userInfo.first_login 
          var subscriptions = userInfo.subscriptions
          this.subscriptions = []
          for (var i = 0; i < subscriptions.length; i++) {
            subscriptions[i].autotrade_amount = subscriptions[i].percent_usdt ? userInfo.binance_usdt_total_balance * subscriptions[i].percent_usdt_amount / 100 : (subscriptions[i].autotrade ? subscriptions[i].autotrade_amount : '')
            this.subscriptions.push(subscriptions[i])
          }
          if (userInfo.plan_status === 1) {
            this.selected_tab = 2
          } else if (userInfo.plan_status === 2) {
            this.selected_tab = 1
          }
          // this.subscriptions = userInfo.subscriptions.sort(function (a, b) {return a.name.localeCompare(b.name);})
          // this.subscriptions = userInfo.subscriptions
          this.subscriptions = this.subscriptions.sort((a, b) => { return a.status - b.status })
          // this.subscriptions = this.subscriptions_1.sort(function (a, b) {return b.autotrade_amount - a.autotrade_amount})
          // this.latest_alerts = userInfo.latest_alerts
          // this.loadChartData()
          // this.data_loaded = true
        })
    },
    sortSubscriptions (flag) {
      if (flag) {
        this.subscriptions = this.subscriptions.sort(function (a, b) { return b.name.localeCompare(a.name) })
      } else {
        this.subscriptions = this.subscriptions.sort(function (a, b) { return a.name.localeCompare(b.name) })
      }
    },
    sortSubscriptionsByamount (flag) {
      if (flag) {
        console.log(flag)
        this.subscriptions = this.subscriptions.sort(function (a, b) { return b.autotrade_amount - a.autotrade_amount })
      } else {
        this.subscriptions = this.subscriptions.sort(function (a, b) { return a.autotrade_amount - b.autotrade_amount })
      }
    }

  }
}
</script>

<style lang="css" scoped>
  .navbar-nav .dropdown-menu {
      position: absolute !important;
      float: none !important;
      /* right: -30px !important; */
      left: 0;
      top: 50px !important;
      width: 50px !important;
  }
  .dropdown-item:hover {
    color: white !important;
  }
  #navbarDarkDropdownMenuLink:hover#b{
    display: block !important;
  }

  @media(max-width: 767px) {
  .navbar-nav .dropdown-menu {
      position: absolute !important;
      float: none !important;
      /* right: -30px !important; */
      left: -25px;
      top: 50px !important;
  }
}

  .navbar .navbar-menu-wrapper .navbar-nav .nav-item.dropdown i {
    margin-right: .5rem;
    vertical-align: middle;
    color: white !important;
    font-size: 1.25rem;
  }

  .navbar .navbar-menu-wrapper .navbar-nav.navbar-nav-right .nav-item:first-child.dropdown .dropdown-toggle:after {
    display: inline-block;
    color: white !important;
}

.fa-fw {
    text-align: center;
    width: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardLayout.vue